import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
/* eslint-disable @repo/internal/react/consistent-props-definitions */
/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import Button from '@atlaskit/button';
import ChevronDownIcon from '@atlaskit/icon/glyph/chevron-down';
import ChevronRightIcon from '@atlaskit/icon/glyph/chevron-right';
import { ChevronContainer, ChevronIconContainer, iconColor } from './styled';
export default class Chevron extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "handleClick", () => {
      if (this.props.onExpandToggle) {
        this.props.onExpandToggle();
      }
    });
  }
  render() {
    const {
      isExpanded,
      ariaControls,
      collapseLabel,
      expandLabel,
      rowId,
      extendedLabel
    } = this.props;
    const iconProps = {
      size: 'medium',
      primaryColor: iconColor
    };
    const getLabel = defaultLabel => extendedLabel ? `${defaultLabel} ${extendedLabel} row` : `${defaultLabel} row ${rowId}`;
    return /*#__PURE__*/React.createElement(ChevronContainer, null, /*#__PURE__*/React.createElement(Button, {
      spacing: "none",
      appearance: "subtle",
      "aria-controls": ariaControls,
      onClick: this.handleClick
    }, /*#__PURE__*/React.createElement(ChevronIconContainer, null, isExpanded ? /*#__PURE__*/React.createElement(ChevronDownIcon, _extends({
      label: getLabel(collapseLabel)
    }, iconProps)) : /*#__PURE__*/React.createElement(ChevronRightIcon, _extends({
      label: getLabel(expandLabel)
    }, iconProps)))));
  }
}
_defineProperty(Chevron, "defaultProps", {
  expandLabel: 'Expand',
  collapseLabel: 'Collapse'
});